import { ACCESS, ROLES } from '../constants/permissions/roles.js';

const LINKS_PERMISSIONS = {
    main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_links: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_payments: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
};

export const PERMISSIONS = {
    DOWNLOAD_LIST: 'general.download_list',
};

export const userPermissions = {
    show_clients: {
        main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_details: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_device: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_telephones: ACCESS.INTERNAL,
        sub_email: ACCESS.INTERNAL,
        sub_address: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_links: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    },
    show_products: {
        main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL],
        show_links: LINKS_PERMISSIONS,
    },
    show_users: [...ACCESS.INTERNAL, ROLES.userAdmin],
    show_management: {
        main: [...ACCESS.ALL, ...ACCESS.FRAUD_PREVENTION],
        sub_cancellations: ACCESS.INTERNAL,
        sub_consultants: ACCESS.ALL,
        sub_consultants_load: ACCESS.INTERNAL,
        sub_antifraud: [...ACCESS.INTERNAL, ...ACCESS.FRAUD_PREVENTION],
    },
};

export const actionPermissions = {
    consultants: {
        load: ACCESS.INTERNAL,
    },
    paymentLinks: {
        link_block_button: ACCESS.ADMIN,
    },
    general: {
        download_list: ACCESS.INTERNAL,
    },
    users: {
        create: [ROLES.admin, ROLES.userAdmin],
        edit: [ROLES.admin, ROLES.userAdmin],
        delete: [ROLES.admin, ROLES.userAdmin],
    }
};

export const checkUserPermission = (user, action) => {
    if (!user || !user.roles || !user.roles.length) {
        return checkPermissions(action);
    }
    return user.roles.some(userRole => {
        const roleId = userRole.role.id;

        const allPermissions = {
            ...userPermissions,
            ...actionPermissions,
        };
        const keys = action.split('.');
        let current = allPermissions;

        for (const key of keys) {
            if (current && typeof current === 'object') {
                current = current[key];
            }
            else {
                return false;
            }
        }

        return Array.isArray(current) ? current.includes(roleId) : false;
    });
};

const getUserRole = () => {
    const user = localStorage.getItem('sessionUser');
    if (!user) return null;
    const userRole = JSON.parse(user)?.roles[0];
    const roleId = userRole?.role.id;
    return roleId;
};

export const checkPermissions = (action) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return false;
    }

    const roleId = getUserRole();
    if (!roleId) return false;

    const allPermissions = {
        ...userPermissions,
        ...actionPermissions,
    };
    const keys = action.split('.');
    let current = allPermissions;

    for (const key of keys) {
        if (current && typeof current === 'object') {
            current = current[key];
        }
        else {
            return false;
        }
    }

    return Array.isArray(current) ? current.includes(roleId) : false;
};

export const getDefaultFallbackPath = () => {
    const roleId = getUserRole();
    if (!roleId) return '/logout';
    const role = Object.values(ROLES).find(roleValue => roleValue === roleId);
    if (!role) return '/logout';
    switch (role) {
        case ROLES.admin:
            return '/clients';
        case ROLES.operator:
            return '/clients';
        case ROLES.externalSupport:
            return '/managment/consultants';
        case ROLES.fraudPrevention:
            return '/managment/fraudPrevention';
        case ROLES.fraudPreventionAdmin:
            return '/managment/fraudPrevention';
        case ROLES.userAdmin:
            return '/users';
        default:
            return '/logout';
    }
};
